export function initChatBubbles() {
  // Check if chat bubble element exists
  const chatBubbles = document.getElementById("chat-bubble");

  if (chatBubbles) {
    const chatToggle = chatBubbles.querySelector(".chat-btn-toggle");
    const chatItems = chatBubbles.querySelectorAll(".chat-item");
    const chatModals = chatBubbles.querySelectorAll(".bubble-modal");

    function toggleChatBubble() {
      chatBubbles.classList.toggle("active");
    }

    function closeChatBubble() {
      chatBubbles.classList.remove("active");
    }

    function openChatModal(targetId) {
      chatModals.forEach((chatModal) => {
        if (chatModal.id === targetId) {
          chatModal.classList.add("active");
        } else {
          chatModal.classList.remove("active");
        }
      });
    }

    function closeChatModal() {
      chatModals.forEach((chatModal) => {
        chatModal.classList.remove("active");
      });
    }

    chatToggle.addEventListener("click", (e) => {
      e.preventDefault();
      closeChatModal();
      toggleChatBubble();
    });

    // Open Chat Modal when clicking on chat items
    chatItems.forEach((chatItem) => {
      chatItem.addEventListener("click", (e) => {
        const target = chatItem.getAttribute("data-bubble-modal");
        if (target) {
          e.preventDefault();
          openChatModal(target);
        }
      });
    });

    chatModals.forEach((chatModal) => {
      const chatModalClose = chatModal.querySelector(".bubble-modal-close");
      chatModalClose.addEventListener("click", (e) => {
        e.preventDefault();
        closeChatModal();
      });
    });

    // Close Chat Bubble and Modals when clicking outside
    document.addEventListener("click", (e) => {
      if (!chatBubbles.contains(e.target) && !chatToggle.contains(e.target)) {
        closeChatBubble();
        closeChatModal();
      }
    });
  }
}
